import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const GoodsSchema = z
  .object({
    goodsNo: z.number(),
    imageUrl: z.string(),
    brandName: z.string(),
    goodsName: z.string(),
    salesRate: z.number(),
    price: z.number(),
    isSoldOut: z.boolean(),
  })
  .describe('GoodsSchema');

const GetReverseProposalRequestSchema = z
  .object({
    reverseProposalId: z.number(),
  })
  .describe('GetReverseProposalRequestSchema');

export type GetReverseProposalRequest = z.infer<typeof GetReverseProposalRequestSchema>;

const GetReverseProposalResponseDataSchema = z
  .object({
    campaignReverseProposalId: z.number(),
    brandImageUrl: z.string(),
    status: z.enum(['WAITING', 'APPROVED', 'REJECTED']),
    brandName: z.string(),
    createdAt: z.string(),
    startAt: z.string(),
    goods: GoodsSchema,
    curatorCouponCampaignProposalId: z.number().nullable().optional(),
  })
  .describe('GetReverseProposalResponseDataSchema');

const GetReverseProposalResponseSchema = createApiResponseSchema(
  GetReverseProposalResponseDataSchema,
);

export type GetReverseProposalResponse = z.infer<typeof GetReverseProposalResponseSchema>;

export const getReverseProposal = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetReverseProposalRequestSchema),
    async (params: GetReverseProposalRequest): Promise<GetReverseProposalResponse> =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.get<GetReverseProposalResponse>(
          urlJoin(campaignsApiPath.getReverseProposal(params.reverseProposalId)),
        );
        return response;
      }),
    validateApiResponse(GetReverseProposalResponseSchema),
  ),
);
